/** Markets where the shipping line omits the product name (they know it). */
export const PRODUCT_NAME_OMITTED = [
  'US', 'PR', 'IN', 'AE',
  'CH', 'IS', 'GB', 'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI',
  'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'MC', 'NL',
  'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'FO', 'NO', 'ZA', 'HK',
] as const;

/** Non-shippable geos: no shipping tile, and Ring AIR counts as unavailable. */
export const EXCLUDED_REGIONS = [
  'PK', 'SY', 'SS', 'YE', 'ET', 'BY', 'CF', 'ER',
  'IQ', 'KP', 'LY', 'PS', 'RU', 'SO',
] as const;

const has = (list: readonly string[], region: string) => list.includes(region);

export const omitsProductName = (region: string) => has(PRODUCT_NAME_OMITTED, region);
export const isExcludedRegion = (region: string) => has(EXCLUDED_REGIONS, region);
export const isRingAirUnavailable = (region: string) =>
  region === 'US' || region === 'PR' || isExcludedRegion(region);
